import { StatusContainer } from "./style";

interface IProps {
  status: "processando" | "itensComErro" | "concluido";
  width?: string;
}

export function StatusLoteBloqueio({ status, width }: IProps) {
  const strategy = {
    processando: {
      texto: "Processando",
      backgroundColor: "#F2F2F2",
      color: "#6E6E6E",
      border: "1px solid #6E6E6E",
    },
    itensComErro: {
      texto: "Itens com erro",
      backgroundColor: "#FFE4E4",
      color: "#EE5353",
      border: "1px solid #EE5353",
    },
    concluido: {
      texto: "Concluído",
      backgroundColor: "#E6F9F0",
      color: "#2EAD65",
      border: "1px solid #2EAD65",
    },
  };

  const statusConfig = strategy[status];

  return (
    <StatusContainer width={width} style={statusConfig}>
      {statusConfig.texto}
    </StatusContainer>
  );
}
